import { toast } from "sonner";
import { t } from "@/lib/i18n";

export async function copyText(text, label) {
  try {
    await navigator.clipboard.writeText(text);
    toast.success(label || t("common.copied"));
  } catch (e) {
    const ta = document.createElement("textarea");
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    try {
      document.execCommand("copy");
      toast.success(label || t("common.copied"));
    } catch (err) {
      toast.error(t("common.error"));
    }
    document.body.removeChild(ta);
  }
}
